/*!
 * Copyright © 2018-2021. Verizon Connect Ireland Limited. All rights reserved.
 */

import { IVehiclePlot, IHotspotPlot, IGeofencePlot, IGarminStopPlot, IWorkOrderPlot, IIndexableObject, IAssetPlot } from '../../models';

export interface IPlotsState {
  vehiclePlots: IVehiclePlot[];
  hotspotPlots: IHotspotPlot[];
  geofencePlots: IGeofencePlot[];
  garminStopsPlots: IGarminStopPlot[];
  workOrdersPlots: IWorkOrderPlot[];
  assetsPlots: IAssetPlot[];
  vehiclePlotsTimers: IIndexableObject<number>;
  vehiclePlotsLoaded: boolean;
  assetPlotsLoaded: boolean;
}

export const initialPlotsState: IPlotsState = {
  vehiclePlots: [],
  hotspotPlots: [],
  geofencePlots: [],
  garminStopsPlots: [],
  workOrdersPlots: [],
  assetsPlots: [],
  vehiclePlotsTimers: {},
  vehiclePlotsLoaded: false,
  assetPlotsLoaded: false
};
